import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setIsFalsePositive')(function setIsFalsePositive(
    viewState: PolicyTipsViewState,
    isFalsePositive: boolean
) {
    viewState.isReportedFalsePositive = isFalsePositive;
});
